<template>
    <modal className="max-w-sm w-full" @close="handleClose">
        <template #header>
            Update Chart Notes
        </template>
        <template #body>
            <div class="flex flex-wrap my-2">
                <div class="w-full bg-tan-200 text-center py-2 px-2 border mb-2 border-gray-200">
                    <p class="text-base font-bold leading-none text-blue-500">{{ symbolDisplay }}</p>
                </div>
                <div class="w-full">
                    <label for="notes" class="form-label-class">Chart Notes:</label>
                    <textarea id="notes" type="text" rows="4" placeholder="Enter notes for your Daily chart..." class="form-input form-input-sm" v-model="notes"></textarea>
                </div>
            </div>
        </template>
        <template #footer>
            <div class="flex justify-center">
                <div class="btn btn-sm btn-yellow-ghost inline-flex mx-1" @click="handleClose">Cancel</div>
                <div class="btn btn-sm btn-yellow inline-flex mx-1" @click="update">Update</div>
            </div>
        </template>
    </modal>
</template>

<script setup>
import { ref } from 'vue';

// Define props
const props = defineProps({
    chart: {
        type: Object,
        required: true
    }
});

// Define emits
const emit = defineEmits(['close', 'update']);

// Reactive state
const notes = ref(props.chart.notes);
const symbolDisplay = ref(props.chart.symbol_display);

// Methods
const update = () => {
    const route = window.route('my-folder.chart-book.update-chart', { chart: props.chart });
    axios.post(route, { notes: notes.value })
        .then((response) => {
            emit('update', response.data.chart);
            emit('close');
        }).catch(error => {
            // Error handling
        });
};

const handleClose = () => {
    emit('close');
};
</script>
